import {api} from "../ModuloGerenciador/UrlPadrao";

export interface CadastrarPrestacaoServicoDto {
    embarqueId: number;
    empresaSubId: number;
    token: string;
}

export const buscarTodosContratosPrestacaoServico = async ({
                                                               token,
                                                               dataInicial,
                                                               dataFinal,
                                                               empresaSubId
                                                           }: {
    token: string,
    dataInicial: string,
    dataFinal: string,
    empresaSubId?: number
}): Promise<any[]> => {
    const response = await api.get(`prestacao-servicos/Todos/${dataInicial}/${dataFinal}/${empresaSubId ? empresaSubId : -1}`, {
        headers: {
            'Authorization': token
        }
    });
    return response.data;
};

export const buscarDocumentoContratoPrestacaoServico = async ({token, idContrato}: {
    token: string,
    idContrato: string
}): Promise<Blob> => {
    const response = await api.get(`prestacao-servicos/Documento/${idContrato}`, {
        headers: {
            'Authorization': token
        },
        responseType: 'blob'
    });
    return response.data;
}

export const buscarContratoPrestacaoServicoPorId = async ({token, id}: { token: string, id: string }): Promise<any> => {
    const response = await api.get(`prestacao-servicos/contrato`, {
        headers: {
            'Authorization': token
        }
    });
    return response.data;
}

export const editarContratoPrestacaoServico = async ({token, idPrestacaoServico, dados}: {
    token: string,
    idPrestacaoServico: string,
    dados: any
}): Promise<any> => {
    const response = await api.put(`prestacao-servicos/contrato/${idPrestacaoServico}`, dados, {
        headers: {
            'Authorization': token
        }
    });
    return response.data;
}

export const deletarContratoPrestacaoServico = async ({token, idPrestacaoServico}: {
    token: string,
    idPrestacaoServico: string
}): Promise<void> => {
    await api.delete(`prestacao-servicos/${idPrestacaoServico}`, {
        headers: {
            'Authorization': token
        }
    });
}

export const cadastrarContratoPrestacaoServico = async ({
                                                            token, empresaSubId,
                                                            embarqueId
                                                        }: CadastrarPrestacaoServicoDto): Promise<any> => {
    const response = await api.post(`prestacao-servicos/Salvar`, {
        empresaSubId,
        embarqueId
    }, {
        headers: {
            'Authorization': token
        }
    });
    return response.data;
};